export default __webpack_public_path__ + "../images/legend-has-acars-alert-unread.svg";